"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConfigurationBuilder = void 0;
var configurationBuilder_1 = require("./configurationBuilder");
Object.defineProperty(exports, "createConfigurationBuilder", { enumerable: true, get: function () { return configurationBuilder_1.createConfigurationBuilder; } });
